<script type="text/javascript">
	import { onMount } from "svelte";
	import Feature from "../Branding/Feature";
	import User from "../Branding/User";
	import LoadState from "../Enums/LoadState";
	import LoadingStore from "../LoadingStore";
	import { ColorScaleSimple } from "../Map/MapLayerStyles";
	import MapStore from "../Map/Store";
	import "../UI/LayerList/LayerList.scss";
	import LayerListSwitch from "../UI/LayerList/LayerListSwitch.svelte";
	import ModalWindow from "../UI/ModalWindow.svelte";
	import HurricaneDataLayer from "./HurricaneDataLayer";
	import HurricanesStore from "./HurricanesStore";
		
	let hurricanesLoadState = HurricanesStore.meta.loadState;
	let hurricanesLoaded = false;
	$: {
		hurricanesLoaded = $hurricanesLoadState === LoadState.LOADED;
	}

	let hurricanesVisible = MapStore.hurricanesVisible;
	MapStore.hurricanesVisible.subscribe((visible) => {
		if (visible && User.hasFeature(Feature.HURRICANES.VIEW)) {
			HurricanesStore.actions.init();
		}
	});

	let forecastPositionVisible = HurricanesStore.meta.layerData[HurricaneDataLayer.FORECAST_POSITION].visible;
	let forecastErrorConeVisible = HurricanesStore.meta.layerData[HurricaneDataLayer.FORECAST_ERRORCONE].visible;
	let historicPositionVisible = HurricanesStore.meta.layerData[HurricaneDataLayer.HISTORIC_POSITION].visible;
	let force34KtsVisible = HurricanesStore.meta.layerData[HurricaneDataLayer.FORCE_34KNOTS].visible;
	let force50KtsVisible = HurricanesStore.meta.layerData[HurricaneDataLayer.FORCE_50KNOTS].visible;
	let force64KtsVisible = HurricanesStore.meta.layerData[HurricaneDataLayer.FORCE_64PLUSKNOTS].visible;

	let opacity = HurricanesStore.meta.opacity;

	$: {
		$hurricanesVisible;
		$forecastPositionVisible;
		$forecastErrorConeVisible;
		$historicPositionVisible;
		$force34KtsVisible;
		$force50KtsVisible;
		$force64KtsVisible;
		$opacity;
		HurricanesStore.actions.updateVisibility();
	}

	let hstyle = "font-weight:bold;margin-top:5px;margin-bottom:5px;";


	// Look at the gradient colors (MapLayerStyles.js) and build a gradient.

	let generateLinearGradient = (colorScale, maxValue) => {
		const amountColors = (colorScale.length)/2;
		let gradientString = "";
		gradientString += "linear-gradient(";
		gradientString += "	to right,";
		for(var i = 0; i < amountColors; i++) {
			const percentage = Math.round(colorScale[(i*2)] * 100 / maxValue);
			const color = colorScale[(i*2) + 1];
			gradientString += color + " " + percentage + "%" + ((i != amountColors-1)?",":"");
		}
		gradientString += ")";
		return gradientString;
	};
	let generateSteppedGradient = (colorScale, maxValue) => {
		// const amountColors = (colorScale.length)/2;
		// let gradientString = "";
		// for(var i = 0; i < amountColors; i++) {
		// 	const percentage = Math.round(colorScale[(i*2)] * 100 / maxValue);
		// 	const color = colorScale[(i*2) + 1];
		// 	gradientString += "linear-gradient(to right," + color + "," + color + ")";
		// 	if (i < amountColors.length-1) {
		// 		gradientString += ",";
		// 	}
		// }
		// gradientString += ";";
		// return gradientString;
		const amountColors = (colorScale.length)/2;
		let gradientString = "";
		gradientString += "linear-gradient(";
		gradientString += "	to right,";
		for(var i = 0; i < amountColors; i++) {
			const percentage = Math.round(colorScale[(i*2)] * 100 / maxValue);
			const color = colorScale[(i*2) + 1];
			//if (percentage > 0 && percentage < 1) {
			if (i > 0 && i < amountColors-1) {
				const prevColor = colorScale[((i-1)*2) + 1];
				gradientString += prevColor + " " + (percentage-0.001) + "%" + ((i != amountColors-1)?",":"");
			}
			gradientString += color + " " + percentage + "%" + ((i != amountColors-1)?",":"");
		}
		gradientString += ")";
		return gradientString;
	};

	let key = generateSteppedGradient(ColorScaleSimple, 100);

	onMount(()=>{
		return LoadingStore.onMount("tropical_storms", hurricanesLoadState);
	});


</script>


<style type="text/css">
	.key-container {
		width:94%;
		margin-left:3%;
		margin-right:3%;
	}
	.heatmap-key-gradient {
		width:calc(100% - 2px);
		height:40px;
		border-radius: 2px;
		border:1px solid #666;
		background-image: var(--background);
	}
	.heatmap-key-scale {
		border:1px solid white;
		width: calc(100% - 2px);
		height: 30px;

	}
	.heatmap-key-scale div {
		font-size:9px;
		position:relative;
		text-align:center;
		top: 0px;
		width: 5px;
		margin-left:-5px;
		display:inline-block;
	}
</style>


{#if hurricanesLoaded}
	<ModalWindow
		title={`Tropical Storms`}
		hasCloseButton={true}
		hasBackground={false}
		resizable={true}
		draggable={true}
		fullscreen={false}
		padding={true}
		position="top-right"
		height="70%"
		bind:open={$hurricanesVisible} >

		<p style={hstyle}>Layers</p>
		<div class='layer-list-component'>
			<LayerListSwitch label={HurricaneDataLayer.FORECAST_POSITION} bind:checked={$forecastPositionVisible} />
			<LayerListSwitch label={HurricaneDataLayer.FORECAST_ERRORCONE} bind:checked={$forecastErrorConeVisible} />
			<LayerListSwitch label={HurricaneDataLayer.HISTORIC_POSITION} bind:checked={$historicPositionVisible} />
			<LayerListSwitch label={HurricaneDataLayer.FORCE_34KNOTS} bind:checked={$force34KtsVisible} />
			<LayerListSwitch label={HurricaneDataLayer.FORCE_50KNOTS} bind:checked={$force50KtsVisible} />
			<LayerListSwitch label={HurricaneDataLayer.FORCE_64PLUSKNOTS} bind:checked={$force64KtsVisible} />
			<div class="layer-list-item">
				<div class='lli-label'>Opacity</div>
				<div class='lli-switch'>
					<input
						type="range"
						min="0"
						max="100"
						step="1"
						value={$opacity*100}
						style="margin-top:10px"
						on:input={(e) => {
							$opacity = parseFloat(e.target.value) * 0.01;
						}}>
				</div>
			</div>
		</div>
		<h3>Key (Probability)</h3>
		<div class='key-container'>
			<div class='heatmap-key-gradient' style="--background:{key}"></div>
			<div class='heatmap-key-scale'>
				{#each ColorScaleSimple as item, index}
					{#if !Number.isNaN(parseInt(item))}
						<div style={"left:" + item + "%;"}>{item}%</div>
					{/if}
				{/each}
			</div>
		</div>
		<p class='data-attribution'>This data is provided by <a href='https://www.nhc.noaa.gov/' target='new'>NOAA National Hurricane Center</a> (NHC) for the Central + East Pacific and Atlantic, and the <a href='https://www.metoc.navy.mil/jtwc/jtwc.html' target='new'>Joint Typhoon Warning Center</a> for the West + Central Pacific and Indian basins.</p>
	</ModalWindow>
{/if}
